<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />

        <vs-spacer />

        <back-original-user v-if="!isOriginalUser" />

        <!-- <i18n /> -->

<!--        <search-bar />-->

<!--        <notification-drop-down />-->

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
  // import I18n                 from "./components/I18n.vue"
  import SearchBar            from "./components/SearchBar.vue"
  import ProfileDropDown      from "./components/ProfileDropDown.vue"
  import BackOriginalUser     from "./components/BackOriginalUser.vue"
  import NotificationDropDown from "./components/NotificationDropDown.vue"

  import moduleUser from '@/store/user/moduleUser.js'

  export default {
    name: "the-navbar-vertical",
    props: {
      navbarColor: {
        type: String,
        default: '#fff'
      }
    },
    components: {
      // I18n,
      SearchBar,
      ProfileDropDown,
      BackOriginalUser,
      NotificationDropDown
    },
    computed: {
      navbarColorLocal() {
        if (this.$store.state.theme === "dark" && this.navbarColor === "#fff") {
          return '#10163a'
        }

        return this.navbarColor
      },
      verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth
      },
      textColor() {
        return {
          'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark')
                  || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')
        }
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },
      // NAVBAR STYLE
      classObj() {
        if (this.verticalNavMenuWidth === 'default') {
          return "navbar-default"
        }

        if (this.verticalNavMenuWidth === 'reduced') {
          return "navbar-reduced"
        }

        if (this.verticalNavMenuWidth) {
          return "navbar-full"
        }
      },
      isOriginalUser() {
        return this.$store.state.user.isOriginalUser
      }
    },
    created() {
      if(!moduleUser.isRegistered) {
        this.$store.registerModule('user', moduleUser)
        moduleUser.isRegistered = true
      }
    },
    methods: {
      showSidebar() {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  }
</script>

